import type React from 'react';

/**
 * Translucent green/red cell background whose intensity scales with |value| / scale, for P&L heatmaps
 * (calendar days, comparison tables). Returns no style for zero, missing, or unscaled values.
 */
export function heatmapStyle(value: number | null | undefined, scale: number): React.CSSProperties {
    if (value === null || value === undefined || value === 0 || scale <= 0) {
        return {};
    }

    const intensity = Math.min(Math.abs(value) / scale, 1);
    const alpha = 0.08 + intensity * 0.32;

    if (value > 0) {
        return { backgroundColor: `rgba(34, 197, 94, ${alpha.toFixed(3)})` };
    }

    return { backgroundColor: `rgba(239, 68, 68, ${alpha.toFixed(3)})` };
}
